<template>
  <div>

    <div class="bar_nav">
      <div class="title">编辑相册名</div>
      <div class="bar_back_btn" @click="goToAlbumHome">返回</div>
    </div>
    <div class="bar_empty"></div>

    <div class="form">
      <input class="field" label="名称" placeholder="请输入相册名称" type="text" v-model="album.name" />
      <div class="btn_large" @click="updateAlbum">确定</div>
    </div>

  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'EditAlbumName',
  data: function () {
    return {
      album: ''
    }
  },
  async created() {
    try {
      this.album = await this.$faApi.getAlbumInfo(this.$route.params.groupId, this.$route.params.albumId)
    } catch (err) {
      this.$faLoggr.error('EditAlbumName.vue:created', err)
    }
  },
  methods: {
    async updateAlbum() {
      try {
        if (!this.album.name) {
          return Toast({
            message: '名字不能为空'
          })
        }
        await this.$faApi.updateAlbum(this.$route.params.groupId, 
          this.$route.params.albumId, {
            name: this.album.name
          })
        this.$router.push({ path: `/group/${this.$route.params.groupId}/album/${this.$route.params.albumId}` })
      } catch (err) {
        this.$faLoggr.error('EditAlbumName.vue:goToGroupSetting', err)
      }
    },
    goToAlbumHome() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/album/${this.$route.params.albumId}` })
    }
  }
}
</script>

<style scoped lang="scss">
  .nav_bar {
    margin-top: 20px;
  }
</style>
  